import React from "react";

interface ErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.error("[ErrorBoundary]", error, info);
    }
  }

  handleReload = () => {
    window.location.assign("/");
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div
          role="alert"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            padding: "2rem",
            textAlign: "center",
          }}
        >
          <h1 style={{ fontSize: "1.75rem", marginBottom: "1rem" }}>
            Algo deu errado.
          </h1>
          <p style={{ marginBottom: "1.5rem", opacity: 0.8, maxWidth: 480 }}>
            Encontramos um erro inesperado ao carregar esta página. Tente
            recarregar.
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              padding: "0.75rem 1.5rem",
              borderRadius: 8,
              border: 0,
              background: "#1E90FF",
              color: "#fff",
              cursor: "pointer",
              fontSize: "1rem",
            }}
          >
            Voltar para a página inicial
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
